import { getFiGrowthBook } from '../lib/growthbook';
import useHardwareFirstCheckout from './useHardwareFirstCheckout';

/**
 * The redesigned cart and checkout for the hardware-first arm, behind 'ecom-cart-checkout-v2'.
 * Off, and outside the arm, today's cart (`HardwareFirstCartLegacy`) and checkout render.
 */
export default function useCartCheckoutV2(): boolean {
  return useHardwareFirstCheckout() && getFiGrowthBook().getFeatureValue<boolean>('ecom-cart-checkout-v2', false);
}
